module.exports = __webpack_public_path__ + "static/media/pagebuilder.e3247fe1.svg";